import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { PlacardDetailsSession } from '../../../api/models/placardDetailsSession';
import { ApiErrorCode, ServiceURLConstants } from '../../../constants/upplm.constants';
import { KeyValue, PlacardOptionsResponse } from '../../../interface/upplm.placard';
import { TranslateDataPipe } from '../../../pipes/translation.pipe';
import { PlacardDetailsHelperService } from '../../../services/PlacardEditionServices/upplm.placardDetailsHelper.service';
import { UpplmApiService } from '../../../services/upplm.api.services';
import { UpsCommonService } from '../../../services/upplm.common.service';
import { PlacardCatalogService } from '../../../services/upplm.placardCatalog.service';
import { StoredDataService } from '../../../services/upplm.storedData.service';


@Component({
    selector: 'editplacarddetails',
    template: require('./editPlacardDetails.component.html'),
    providers: [PlacardCatalogService]
})

export class EditPlacardDetailsComponent implements OnInit {
    placardDetails: PlacardDetailsSession = new PlacardDetailsSession();
    isLoading: boolean = false;
    placardDetailsForm: FormGroup;
    multiOffice: string = '';
    placardTypes: KeyValue[];
    placardSizes: KeyValue[];
    showEditPlacardDetails: boolean = true;
    @Output() hideEditSection = new EventEmitter<boolean>();
    errors: any[] = [];
    showNotificationChanges: boolean = false;

    constructor(private _formBuilder: FormBuilder,
        private _apiService: UpplmApiService,
        private _commonService: UpsCommonService,
        private _storedDataService: StoredDataService,
        private _placardDetailsHelperService: PlacardDetailsHelperService,
        private _translateData: TranslateDataPipe,
        private _placardCatalogService: PlacardCatalogService) {
    }

    ngOnInit(): void {
        this.createForm();
        this.getPlacardDetailsOptions();
    }

    createForm() {
        this.placardDetailsForm = this._formBuilder.group({
            placardSize: new FormControl('', Validators.required),
            placardType: new FormControl('', Validators.required),
        });
    }

    getInitialData() {
        this.placardDetailsForm.setValue({
            placardType: this._storedDataService.placardDetails.placardTypekey,
            placardSize: this._storedDataService.placardDetails.placardSizeKey
        });
        this.multiOffice = this._placardDetailsHelperService.getMultiOfficeValueToShow(this._storedDataService.placardDetails.togglePlacard);
    }

    getPlacardDetailsOptions() {
        this.isLoading = true;
        this.getPlacardSize();
        this._apiService.PostServiceAPI(this._commonService.createURL(ServiceURLConstants.GET_PLACARD_OPTIONS, ApiErrorCode.GET_PLACARD_OPTIONS), null).subscribe((response: PlacardOptionsResponse) => {
            this.placardTypes = this._placardDetailsHelperService.getPlacardType(response.placardType);
            this.getInitialData();
            this.isLoading = false;
        });
    }

    async getPlacardSize() {
        this.placardSizes = await this._placardCatalogService.getPlacardSizeCatalogByCountryCode(this._storedDataService.countryCode);
    }

    focusInput(item: any) {
        document.getElementById(item.id).focus();
    }

    saveEdit() {
        this.isLoading = true;
        this.displayErrors();

        if (this.errors.length == 0) {
            this.saveEditedDataToRequest();
            this.showNotificationsControl(true);
        }
        this.isLoading = false;
    }

    private saveEditedDataToRequest() {
        this._storedDataService.requestEditedData = this._placardDetailsHelperService.prepareSaveEditionRequest(
            this.buildObjectForPrepareRequest());
    }

    private showNotificationsControl(show: boolean) {
        this.showEditPlacardDetails = !show;
        this.showNotificationChanges = show;
    }

    buildObjectForPrepareRequest(): PlacardDetailsSession {
        return {
            togglePlacard: this._storedDataService.placardDetails.togglePlacard,
            placardSizeKey: this.placardDetailsForm.controls.placardSize.value,
            placardTypekey: this.placardDetailsForm.controls.placardType.value
        } as PlacardDetailsSession;
    }

    cancel() {
        this._storedDataService.clearEditingSections();
        this.hideEditSection.emit(true);
    }

    displayErrors() {
        this.errors = [];
        if (this.placardDetailsForm.controls.placardSize.value === '') {
            this.errors = this.errors.concat(this.addError('placardDetails',
                this._translateData.transform('upplm.placarddetails.placardsizeisrequired'), 'required'));
        }
        if (this.placardDetailsForm.controls.placardType.value === '') {
            this.errors = this.errors.concat(this.addError('placardDetails',
                this._translateData.transform('upplm.placarddetails.placardtypeisrequired'), 'required'));
        }
    }

    addError(id: string, field: string, condition: string): any {
        return [{
            "id": id,
            "displayText": field,
            "type": condition,
            "fieldName": "Name",
            "fieldError": "Name error",
            "fieldErrorDescription": "field Error"
        }];
    }

    hideNotificationChange(showNotificationControl: boolean) {
        this.showNotificationsControl(showNotificationControl);
        if (this._storedDataService.isEditionComplete) {
            this.cancel();
        }
    }
}